import React from "react";
import { connect } from "react-redux";

import {
  getDinnerBookingOptionList,
  getDinnerBookingSelectedOptionID,
  isDinnerBookingCashless,
  isDinnerBookingDayHoliday,
  isDinnerBookingInBasket,
  isDinnerBookingDayExpired
} from "state/school_money/selectors";
import { selectDinnerBookingOption } from "state/school_money/actions";

import DailyBookingInput from "components/school_money/DailyBookingInput";

const inputTypes = DailyBookingInput.types;

class DailyMealInput extends React.Component {
  
  onChange = optionID => {
    const { dinnerBookingID, weekdayIndex, isCashless } = this.props;
    if (isCashless && optionID !== null) {
      optionID = Number(optionID);
    }
    this.props.selectDinnerBookingOption(dinnerBookingID, weekdayIndex, optionID);
  }
  
  render() {
    
    const { weekdayIndex, weekdayName, optionList, selectedOptionID, isCashless, isHoliday, isInBasket, isExpired } = this.props;
    
    /**
     * TODO: Migrate away from DailyBookingInput. ClubBooking no longer
     *   uses DailyBookingInput, meaning that DinnerBooking is now the
     *   only use for it. Therefore, it doesn't really need to exist.
     */
    return (
      <DailyBookingInput
        weekdayIndex={weekdayIndex}
        weekdayName={weekdayName}
        cssBlockName="daily-meal-input"
        type={isCashless ? inputTypes.DROPDOWN : inputTypes.RADIO_BUTTONS}
        options={optionList}
        selectedOptionID={String(selectedOptionID)}
        onChange={this.onChange}
        disabled={isHoliday || isExpired}
        readOnly={isInBasket}
       onReadOnlyClick={this.props.onReadOnlyClick}
      />
    )
    
  }
  
}

export default connect(
  (state, { dinnerBookingID, weekdayIndex }) => ({
    optionList: getDinnerBookingOptionList(state, dinnerBookingID, weekdayIndex),
    selectedOptionID: getDinnerBookingSelectedOptionID(state, dinnerBookingID, weekdayIndex),
    isCashless: isDinnerBookingCashless(state, dinnerBookingID),
    isHoliday: isDinnerBookingDayHoliday(state, dinnerBookingID, weekdayIndex),
    isInBasket: isDinnerBookingInBasket(state, dinnerBookingID),
    isExpired: isDinnerBookingDayExpired(state, dinnerBookingID, weekdayIndex)
  }),
  { selectDinnerBookingOption }
)(DailyMealInput);



// WEBPACK FOOTER //
// ./src/components/school_money/dinners/DailyMealInput.js